module.exports = __webpack_public_path__ + "img/m-hetongshizhi.6985ccbb.svg";